import React, { createContext, useContext, useState } from "react";

const MembershipRequestsContext = createContext();

export const useMembershipRequestsContext = () => {
  const context = useContext(MembershipRequestsContext);
  if (!context) {
    throw new Error(
      "useMembershipRequestsContext must be used within MembershipRequestsProvider"
    );
  }
  return context;
};

export const MembershipRequestsProvider = ({ children }) => {
  const [membershipRequests, setMembershipRequests] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [sortBy, setSortBy] = useState("createdDateTime");
  const [sortDirection, setSortDirection] = useState("ASC");
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const resetState = () => {
    setMembershipRequests([]);
    setSearchQuery("");
    setStatusFilter("ALL");
    setSortBy("createdDateTime");
    setSortDirection("ASC");
    setPageNumber(0);
    setTotalPages(0);
    setTotalElements(0);
    setHasNextPage(false);
    setHasPreviousPage(false);
    setDataLoaded(false);
  };

  return (
    <MembershipRequestsContext.Provider
      value={{
        membershipRequests,
        setMembershipRequests,
        searchQuery,
        setSearchQuery,
        statusFilter,
        setStatusFilter,
        sortBy,
        setSortBy,
        sortDirection,
        setSortDirection,
        pageNumber,
        setPageNumber,
        totalPages,
        setTotalPages,
        totalElements,
        setTotalElements,
        hasNextPage,
        setHasNextPage,
        hasPreviousPage,
        setHasPreviousPage,
        dataLoaded,
        setDataLoaded,
        resetState,
      }}
    >
      {children}
    </MembershipRequestsContext.Provider>
  );
};
